<template>
    <header>
        <v-row class="padding-header" no-gutters style="justify-content: center">
            <v-col cols="auto">
                <img src="/img/O2/logoO2.png" width="180px" height="100px" />
            </v-col>
        </v-row>

        <v-row class="padding-header padding-bottom-buttons" style="justify-content: center">
            <v-col cols="auto">
                <button class="button-header Helvetica" :class="paso == 0 ? 'button-active' : 'button-inactive'" @click="cambiarReparacion">
                    <span>SOLICITAR REPARACIÓN</span>
                </button>
            </v-col>
            <v-col cols="auto">
                <button class="button-header Helvetica" :class="paso == 0 ? 'button-inactive' : 'button-active'" @click="cambiarInfo">
                    <span>CONSULTAR REPARACIÓN</span>
                </button>
            </v-col>
        </v-row>

        <v-row v-if="paso == 0" no-gutters style="justify-content: center;">
            <div  class="text-repair-container OnAir">
                <v-row no-gutters>                  
                    <div class="text-repair">
                        <v-col cols="12">
                            Para reparar tu dispositivo, necesitamos que rellenes los datos que te solicitamos a continuación (los marcados con * son obligatorios).
                        </v-col>
                        <v-col cols="12">
                            En un plazo máximo de 48 horas laborables desde que nos lo envíes, contactaremos contigo para ir a recoger tu dispositivo.
                        </v-col>
                        <v-col cols="12">
                            La recogida y devolución del dispositivo no tienen costes asociados y la reparación, si tu dispositivo está en garantía, tampoco.  En caso de no estar en garantía, te facilitaremos un presupuesto.
                        </v-col>
                    </div> 
                   
                </v-row>
            </div>
        </v-row>

        <v-row v-if="paso == 1" no-gutter style="justify-content: center">
            <v-col cols="auto">
                <div class="text-header OnAir">
                    Para consultar el estado de tu reparación, solo tienes que cumplimentar los siguientes datos y pulsar el botón Consultar.
                </div>
            </v-col>
        </v-row>
    </header>
</template>

<script>
export default {
    props: {
        paso: {
            type: Number,
            required: true
        }
    },

    methods: {
        cambiarReparacion() {
            this.$router.push('/O2/reparacion')
        },
        cambiarInfo() {
            this.$router.push('/O2/informacion')
        }
    }
};
</script>

<style>
    #O2 .Helvetica {
        font-family: HelveticaNeue, Helvetica;
    }

    /*
        #O2 header {
        min-width: 300px;
        background-image: linear-gradient(to bottom, #25246b, #213179 10%, #1d4a95 19%, #1d62ab 30%, #147abd 40%, #2292cf 50%, #48acde 67%, #70c2e7 84%, #94d2ec);
        }
    */

    #O2 header {
        min-width: 300px;
        background-image: linear-gradient(to bottom, #00008C, #0050FF 50%, #AFD7FF 80%);
    }

    #O2 header .padding-header {
        padding-top:50px;
    }

    #O2 header .button-header {
        width: 300px;
        height: 48px;
        border-radius: 30px;
        font-size: 20px;
        line-height: 1.3;
        text-align: center;
    }

    #O2 header .padding-bottom-buttons {
        padding-bottom: 40px;
    }

    #O2 header .button-inactive {
        border: solid 2px #fff;
        background-color: #fff;
        color: #0019a5;
    }

    #O2 header .button-active {
        border: solid 1px #fff;
        color: #fff;
    }

    #O2 header .text-repair-container {
        min-width: 300px;
        max-width: 620px;
        padding-bottom: 40px;
        font-size: 18px;
        line-height: 1.39;
        text-align: justify;
        color: #fff;
    }

        #O2 header .text-repair {
            padding-bottom: 15px;
            min-width: 300px;
            max-width: 620px;
            padding: 20px;
            font-size: 18px;
            line-height: 1.39;
            color: black;
            border-radius: 15px;
            background-color: white;
            margin-bottom: 30px;
        }

        #O2 header .text-header {
            min-width: 300px;
            max-width: 620px;
            padding: 20px;
            font-size: 18px;
            line-height: 1.39;
            color: black;
            border-radius: 15px;
            background-color:white;
            margin-bottom: 30px;
        }

    @media (max-width: 600px) {
        header {
            padding: 0 18px;
        }
    }
</style>